import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiCompass } = FiIcons;

const NotFoundPage = () => (
  <main className="min-h-[calc(100vh-160px)] bg-slate-50 px-4 py-20 sm:px-6 lg:px-8">
    <div className="mx-auto flex max-w-3xl items-center justify-center text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full rounded-[2.5rem] border border-slate-200 bg-white px-6 py-12 shadow-xl shadow-slate-200/60 sm:px-12 sm:py-16"
      >
        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-3xl bg-indigo-50 text-indigo-600">
          <SafeIcon icon={FiCompass} className="text-4xl" />
        </div>

        <p className="mb-4 text-sm font-black uppercase tracking-[0.3em] text-indigo-600">
          Page not found
        </p>
        <h1 className="mb-5 text-5xl font-black tracking-tighter text-slate-900 sm:text-7xl">
          Looks like you took a wrong turn.
        </h1>
        <p className="mx-auto mb-10 max-w-xl text-lg font-medium leading-relaxed text-slate-500">
          The page you are looking for may have moved, or it may no longer be available.
        </p>

        <Link
          to="/"
          className="inline-flex min-h-[52px] items-center justify-center rounded-2xl bg-slate-900 px-8 py-4 text-base font-black text-white shadow-xl shadow-slate-200 transition-all hover:-translate-y-1 hover:bg-indigo-600"
        >
          <SafeIcon icon={FiHome} className="mr-3" />
          Back to Home
        </Link>
      </motion.div>
    </div>
  </main>
);

export default NotFoundPage;